const productStore = {
    state: () => ({
        logConditions: [],
        metricConditions: [],
        metricAgentConditions: [],
        logAgentConditions: []
    }),
    getters: {
        getCondition: (state) => (conditionType, productTypeCode) => {
            let data = null
            if(conditionType === 'log') {
                data = state.logConditions.find(filter => filter.type === productTypeCode)
            }else if(conditionType === 'metric') {
                data = state.metricConditions.find(filter => filter.type === productTypeCode)
            }else if(conditionType === 'metricAgentManage') {
                data = state.metricAgentConditions.find(filter => filter.type === productTypeCode)
            }else if(conditionType === 'logAgentManage') {
                data = state.logAgentConditions.find(filter => filter.type === productTypeCode)
            }

            return data ? data.filter : null
        }
    },
    mutations: {
        addCondition: (state, datas) => {
            if(datas.conditionType === 'log') state.logConditions.push({type: datas.productTypeCode, filter: datas.data})
            else if(datas.conditionType === 'metric') state.metricConditions.push({type: datas.productTypeCode, filter: datas.data})
            else if(datas.conditionType === 'metricAgentManage') state.metricAgentConditions.push({type: datas.productTypeCode, filter: datas.data})
            else if(datas.conditionType === 'logAgentManage') state.logAgentConditions.push({type: datas.productTypeCode, filter: datas.data})
        },

        resetCondition: (state) => {
            state.logConditions = []
            state.metricConditions = []
            state.metricAgentConditions = []
            state.logAgentConditions = []
        }
    },
    actions: {
        addCondition: ({commit}, datas) => commit('addCondition', datas)
    }
}

export default productStore